import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ProjectService } from '../../api/services/project.services';
import { Project } from '../../api/models/project-model';
import { IconPickerComponent } from '../../app/icon-picker/icon-picker.component';
import { AuthService } from '../../api/services/auth.service';
import { PreferencesService } from '../../api/services/preferences.service';
import { MarketService } from '../../api/services/market.service';
import { ToastrService } from 'ngx-toastr';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { FileUploadType } from '../../api/models/file-uploaded';
import { BulkProjectOutput } from '../../api/models/bulk-project-output';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-project-creation',
  templateUrl: './project-creation.component.html',
  styleUrls: ['./project-creation.component.scss']
})
export class ProjectCreationComponent implements OnInit {

  marketId: string;
  icon: string;
  project: Project;
  createComponentForm: FormGroup;
  optionSelected = false;
  hasFile = false;
  manually = false;
  uploaded = false;
  errorCreatingByFile = false;
  errorMessage: string;
  accountNumber: string;
  projectManualError = false;
  manualError: string[] = [];
  specialSelected: string = "#";
  roleRequest: RoleRequest;
  isVerizonClient = false;
  isAtcClient = false;
  isNormalClient = false;
  isTesscoAdmin: boolean = false;
  isClientAdmin: boolean = false;
  displayBudget: boolean = true;
  failedProjectNames: string[] = null;
  projectNumber: string = null;
  markAsRecA: boolean = false;
  inheritMarketFlag: boolean = false;
  fuzeId: string;
  validateForm: boolean = true;
  minDate: NgbDateStruct;
  fileUploadType = FileUploadType.XLSX;
  uploadedBiggerFile = false;
  templateFilePath = "";
  bulkProjectOutput: BulkProjectOutput;
  failProjects: string;
  batchId: string;
  showBatchId: boolean = false;
  failedBatch: boolean = false;
  templateText = '';

  constructor(
    public activeModal: NgbActiveModal,
    private projectService: ProjectService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private preferencesService: PreferencesService,
    private modalService: NgbModal,
    private marketService: MarketService,
    private toastr: ToastrService) {
  }

  private onCreateSuccess() {
    this.toastr.success('Project created!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateSuccess() {
    this.toastr.success('Project saved!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  close() {
    this.activeModal.close();
  }

  openIconPicker() {
    const modalRef = this.modalService.open(IconPickerComponent, {
      size: 'lg',
      backdrop : 'static',
      keyboard : false
    });

    modalRef.result.then(result => {
      this.icon = result.icon;
      if (!this.specialSelected || this.specialSelected === 'ATC') {
        this.validateForm = false;
      }
    }).catch();
  }

  onSubmit() {
    this.project.id ? this.updateProject() : this.createProject();
  }

  createProject() {
    this.project = this.createComponentForm.value;
    this.project.accountNumber = this.accountNumber;
    if (this.createComponentForm.value.deliveryDate.getFullYear() < 2000) {
      this.createComponentForm.value.deliveryDate.setFullYear(this.createComponentForm.value.deliveryDate.getFullYear() + 100);
    }
    this.project.marketId = this.marketId;
    this.project.deliveryDate = this.createComponentForm.value.deliveryDate.toISOString();
    this.project.icon = this.icon;
    if (this.specialSelected === 'Verizon eQuote') {
      this.project.fuzeId = this.createComponentForm.value.fuzeId;
    }
    this.project.reca = this.createComponentForm.value.isRecA;
    this.project.inheritMarketPermissions = this.createComponentForm.value.inheritMarketPermissions;

    this.projectService.createProject(this.project).subscribe((project) => {
      if (this.specialSelected === 'Verizon eQuote') {
        this.preferencesService.setPreference('PROJECT', project.id, 'oracle-project-name', { Value: this.project.name }).subscribe();
      }
      if (this.projectNumber && this.projectNumber.length) {
        this.preferencesService.setPreference('PROJECT', project.id, 'oracle-project-number', { Value: this.projectNumber }).subscribe(() => {
          this.activeModal.close(project);
          this.onCreateSuccess();
        });
      } else {
        this.activeModal.close(project);
        this.onCreateSuccess();
      }
    }, err => {
      this.manualError.push(err.error.message);
      this.projectManualError = true;
      let element = document.getElementById('edit-project');
      element.scrollIntoView(true);
    });
  }

  clearManualError(){
    this.manualError = [];
    this.projectManualError = false;
  }

  updateProject() {
    this.project.name = this.createComponentForm.value.name;
    this.project.value = this.createComponentForm.value.value;
    this.project.summary = this.createComponentForm.value.summary;
    this.project.deliveryDate = this.createComponentForm.value.deliveryDate.toISOString();
    this.project.icon = this.icon;
    this.project.reca = this.createComponentForm.value.isRecA;
    this.project.inheritMarketPermissions = this.createComponentForm.value.inheritMarketPermissions;
    this.project.projectPermissions = this.project.projectPermissions.filter(p => !p.marketInherit);
    this.project.updateProjectPermission = false;
    this.project.fuzeId = this.createComponentForm.value.fuzeId;
    this.projectService.updateProject(this.project).subscribe(() => {
      if (this.specialSelected === 'Verizon eQuote') {
        this.preferencesService.setPreference('PROJECT', this.project.id, 'oracle-project-name', { Value: this.project.name }).subscribe();
        this.preferencesService.setPreference('PROJECT', this.project.id, 'oracle-project-number', { Value: this.projectNumber }).subscribe(() => {
          this.activeModal.close([this.projectNumber, this.project.name]);
          this.onUpdateSuccess();
        });
      } else {
        this.activeModal.close(null);
        this.onUpdateSuccess();
      }
    }, err => {
      this.manualError.push(err.error.message);
      this.projectManualError = true;
      let element = document.getElementById('edit-project');
      element.scrollIntoView(true);
    });
  }

  changeOption(option: string) {
    if (option) {
      this.uploaded = true;
      this.optionSelected = true;
    } else {
      this.manually = true;
      this.optionSelected = true;
    }
  }

  biggerFileUploaded(isBiggerFile: boolean) {
    this.uploadedBiggerFile = isBiggerFile;
  }

  onProjectFileUploaded(id: string) {
    this.hasFile = true;
    if (this.uploadedBiggerFile) {
      this.projectService.uploadBulkProjectAsync(id, this.marketId).subscribe(result => {
        this.showBatchId = true;
        if (result) {
          this.batchId = result;
        } else {
          this.failedBatch = true;
        }
      }, error => {
        this.showBatchId = true;
        this.failedBatch = true;
      });
    } else {
      this.projectService.createProjectByImportCsvFile(id, this.marketId).subscribe(result => {
        this.bulkProjectOutput = result;
        this.activeModal.close(null);
        this.onCreateSuccess();
      }, error => {
        this.errorCreatingByFile = true;
        if (error.error.message) {
          this.errorMessage = error.error.message;
        } else if(error.error.responseMessage) {
          this.bulkProjectOutput = error.error;
          this.errorMessage = error.error.responseMessage;
          this.failProjects = "Click here to download the failed projects row details with reason.";
        }
      });
    }
  }

  downloadMyFile(event: any) {
    event.stopPropagation();
    event.preventDefault();
    /* for header */
    var Heading = [
      ["Row Number", "Reason"],
    ];
    /* generate worksheet */
    const ws = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(ws, Heading);
    XLSX.utils.sheet_add_json(ws, this.bulkProjectOutput.failProjectOutputs, { origin: 'A2', skipHeader: true });
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Failed Project Data');
    /* save to file */
    XLSX.writeFile(wb, 'Failed Project Data.xlsx');
  }

  deleteFile() {
    this.hasFile = false;
  }

  ngOnInit() {
    this.createProjectForm();

    this.preferencesService.getPreferences('USER', this.authService.getUserId())
      .subscribe(prefs => {

        this.marketId = prefs['current-market'].Value;

        this.marketService.getMarket(this.marketId).subscribe(market => {
          this.accountNumber = market.accountNumber;

          this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
          this.roleRequest.setRoleAndContextMap('ADMIN_CLIENT', null);
          this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
            this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
            this.isClientAdmin = roles.getRoleMap('ADMIN_CLIENT');

            this.preferencesService.getPreferences('CUSTOMER', market.customerId).subscribe(pref => {
              this.specialSelected = pref['special-fields'].Value;
              if (this.specialSelected === 'Verizon eQuote') {
                this.templateFilePath = "/assets/template-files/Verizon Project Template.xlsx";
                this.isVerizonClient = true;
                this.templateText = ' for Verizon';
                this.displayBudget = false;
                this.preferencesService.getPreferences('PROJECT', this.project.id).subscribe(pre => {
                  this.projectNumber = pre['oracle-project-number'].Value;
                });
                this.createComponentForm && this.createComponentForm.patchValue({
                  'inheritMarketPermissions': this.project && this.project.id ? this.project.inheritMarketPermissions : false
                });
                this.createComponentForm && this.createComponentForm.patchValue({
                  'isRecA': this.project && this.project.id ? this.project.reca : false
                });
              } else if (this.specialSelected === 'ATC') {
                this.templateFilePath = "/assets/template-files/ATC Project Template.xlsx";
                this.isAtcClient = true;
                this.templateText = ' for ATC';
                this.inheritMarketFlag = true;
              } else {
                this.templateFilePath = "/assets/template-files/Project Template.xlsx";
                this.isNormalClient = true;
                this.templateText = '';
                this.inheritMarketFlag = true;
              }
              if(this.project.id){
                this.inheritMarketFlag = this.project.inheritMarketPermissions;
              }
          });
        });
      });
    });

    this.createComponentForm.valueChanges.subscribe(form => {
      if(this.isVerizonClient){
        this.verizonProjectValidation();
      } else {
        this.atcProjectValidation();
      }
    });
  }

  atcProjectValidation(){
    let projectName = this.createComponentForm.value.name;
    let deliveryDate = this.createComponentForm.value.deliveryDate;

    let formattedDeliveryDate = new Date(deliveryDate).getTime();
    let todaysDate = new Date().setHours(0,0,0,0);
    
    if (!projectName || !deliveryDate || (deliveryDate && (formattedDeliveryDate < todaysDate))) {
      this.validateForm = true;
    } else {
      this.validateForm = false;
    }
  }

  verizonProjectValidation(){
    let fuzeid = this.createComponentForm.value.fuzeId;
    let projectNum = this.createComponentForm.value.projectNumber;
    this.atcProjectValidation();

    if(!this.validateForm){
      if(!fuzeid && !projectNum){
        this.validateForm = true;
      } else {
        this.validateForm = false;
      }
    }
  }

  createProjectForm(){
    let date;
    if (this.project.id) {
      this.changeOption('');
      date = new Date(this.project.deliveryDate);
      this.icon = this.project.icon;
      this.fuzeId = this.project.fuzeId;

      let formattedDate = new Date(this.project.deliveryDate).getTime();
      let todaysDate = new Date().setHours(0,0,0,0);
    
      if(formattedDate < todaysDate){
        this.projectManualError = true;
        if(this.specialSelected === 'Verizon eQuote'){
          this.manualError.push("Est. Need-By-Date has to be a date in the future.");
        } else {
          this.manualError.push("Target Delivery Date has to be a date in the future.");
        }
      }
    } else {
      date = null;
      this.icon = '&#xe' + (2306).toString(16);
    }

    var today = new Date();
    this.minDate = {year: today.getFullYear(), month: today.getMonth()+1, day: today.getDate() };

    this.createComponentForm = this.formBuilder.group({
      name: [this.project.name, Validators.required],
      deliveryDate: [date, Validators.required],
      projectNumber: [this.projectNumber],
      fuzeId: [this.project.fuzeId],
      value: [this.project.value],
      summary: [this.project.summary],
      isRecA: [this.project.reca],
      inheritMarketPermissions: [this.project.id ? this.project.inheritMarketPermissions : (this.specialSelected !== 'Verizon eQuote')]
    });
  }

  dateSelected(event){
    this.clearManualError();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/project-creation/project-creation.component.ts